import React from "react";
import CuitInput from "../../../components/formInputCuit";

export default function CertificateForm({ 
  formData, 
  errors, 
  handleChange, 
  disabled,
}) {
  return (
    <>
      <CuitInput
        label="CUIT"
        type="text"
        id="cuit"
        name="cuit"
        customClassName={`${errors.cuit && "is-invalid"}`}
        value={formData.cuit || ""}
        onBlur={handleChange}
        disabled={disabled}
        required
      >
        {errors.cuit && <div className="invalid-feedback">{errors.cuit}</div>}
      </CuitInput>
      <div className="form-group">
        <label htmlFor="clave">Clave Fiscal *</label>
        <b className="form-text mb-1">
          La clave fiscal no se guardará en nuestros servidores. Es sólo para crear la conexión con ARCA (AFIP).
        </b>
        <input
          type="password"
          id="clave"
          name="clave"
          className={`form-control ${errors.clave && "is-invalid"}`}
          value={formData.clave || ""}
          onChange={handleChange}
          disabled={disabled}
          required
        />
        {errors.clave && <div className="invalid-feedback">{errors.clave}</div>}
      </div>
    </>
  );
}
